<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <div
                    class="alert alert-danger"
                >O tamanho das imagens pode impactar diretamente na performance e tempo de carregamento do aplicativo.</div>
                <form @submit.prevent="save">
                    <div class="card">
                        <div class="card-header">
                            <i class="fas fa-mobile-alt"></i> Página
                        </div>
                        <div class="card-block form form-horizontal">
                            <div class="form-group row">
                              <div
                                  class="col-md-4"
                                  :class="{ 'dropdown-has-error': $v.model.id_pais.$error }"
                              >
                                  <label>País*</label>
                                  <select-api
                                      v-model="model.id_pais"
                                      :endpoint="'/pais/pesquisa'"
                                      :opt-text="'nome'"
                                      :select-option="true"
                                  ></select-api>
                              </div>
                            </div>
                            <div class="form-group row">
                                <div
                                    class="col-md-4"
                                    :class="{ 'has-danger': $v.model.nome.$error }"
                                >
                                    <label>Nome*</label>
                                    <input
                                        type="text"
                                        maxlength="150"
                                        class="form-control"
                                        v-model="model.nome"
                                    />
                                </div>

                                <div
                                    class="col-md-4"
                                    :class="{ 'dropdown-has-error': $v.model.codigo.$error }"
                                    >
                                  <label>Tipo*</label>
                                  <Select2
                                      placeholder="Selecione"
                                      v-model="model.codigo"
                                      :options="paginas"
                                  >
                                      <option value selected>Selecione</option>
                                  </Select2>
                                </div>

                                <div class="col-md-3 align-self-center">
                                    <label>Ativo</label>
                                    <br />
                                    <input-toggle v-model="model.ativo" :value="model.ativo"></input-toggle>
                                </div>
                            </div>

                            <div class="alert alert-warning">
                                <strong>Atenção!</strong>
                                O tamanho máximo e indicado para a
                                <strong>Imagem</strong> é de
                                <strong>300kb</strong>.
                            </div>
                            <div class="form-group row">
                                <div class="col-md-12">
                                    <file-image
                                        v-model="imagem"
                                        :label="'Ícone'"
                                        :arquivo="model.arquivo"
                                    ></file-image>
                                </div>
                            </div>
                        </div>

                        <div class="card-footer text-right">
                            <router-link
                                :to="{ name: 'list-page' }"
                                class="btn btn-link"
                            >Cancelar</router-link>
                            <button type="submit" class="btn btn-primary">Salvar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import Facade from "../../facade/facade";
const facade = new Facade();
import {
    required,
    minLength,
    maxLength,
    withParams,
    email
} from "vuelidate/lib/validators";
import {
    isNotUndefinedOrNullOrEmptyOrZero,
    isUndefinedOrNullOrEmpty
} from "@/services/string";
import SelectApi from "../../components/Input/SelectApi";
import FileImage from "../../components/Input/FileImage";
import { isPhone, isCpf, validateCPF } from "@/services/util";
import Collections from "../../helpers/collections";
import Select2 from '../../components/Input/Select2';
export default {
    components: {
        FileImage, Select2, SelectApi
    },
    data() {
        return {
            model: {
                id: null,
                nome: "",
                ativo: 0,
                codigo: "",
                arquivo: null,
                id_pais: ''
            },
            imagem: null,
            paginas: Collections.tipoPagina
        };
    },
    validations() {
        let vm = this;

        return {
            model: {
                nome: {
                    required,
                    minLength: minLength(2)
                },
                codigo: {
                    required,
                    isNotUndefinedOrNullOrEmptyOrZero
                },
                id_pais: {
                  required,
                  isNotUndefinedOrNullOrEmptyOrZero
                }
            }
        };
    },
    methods: {
        async save() {
            let vm = this;
            if (this.$v.model.$invalid) {
                this.$v.model.$touch();
                this.$notify.warning(
                    "Atenção!",
                    "Verifique se todos os campos estão preenchidos corretamente."
                );
                return;
            }

            this.$loading.show(true);

            try {
                const formData = new FormData();
                formData.append("data", JSON.stringify(vm.model));
                formData.append("imagem", vm.imagem);

                if (vm.model.id) {
                    await facade.updatePage(formData, vm.model.id);
                    this.$router.push({ name: "list-page" });
                } else {
                    await facade.createPage(formData);
                    this.$router.push({ name: "list-page" });
                }

                this.$loading.show(false);
            } catch (e) {
                e.forEach(item => {
                    this.$notify.error(item.field, item.message);
                });
                this.$loading.show(false);
            }
        },
        throwError(e) {
            this.$notify.error("Erro!", e);
        },
        setData(model) {
            let vm = this;

            if (model !== undefined && model !== null) {
                vm.model = model;
                vm.corObjeto = vm.model.cor;
            }
        }
    },
    async beforeRouteEnter(to, from, next) {
        let page = null;

        if (to.params.id) {
            page = (await facade.getPage(to.params.id)).data.data;
        }

        next(vm => vm.setData(page));
    }
};
</script>



// WEBPACK FOOTER //
// Form.vue?797fa7b0